import { G, UI, isGM } from "./store";
import { send } from "./net";
import { expand, ExpandCancelled } from "../shared/expand";
import { prompt, choose } from "./util";
import type { Char, Macro } from "../shared/types";

/** Expand macros/attributes/queries client-side, then send to the server (which rolls). */
export async function sendChat(text: string, asCharId?: string) {
  const s = G.get();
  const ui = UI.get();
  const as = asCharId ?? ui.speakAs ?? "";
  const chars = Object.values(s.recs.char) as Char[];
  const macros = (Object.values(s.recs.macro) as Macro[]).filter(m => m.owner === s.me || m.shared || isGM());
  // own macros take precedence over shared ones with the same name
  macros.sort((a, b) => (a.owner === s.me ? -1 : 0) - (b.owner === s.me ? -1 : 0));
  const selected = ui.selected.map(id => s.recs.obj[id]).find(o => o && o.type === "image") ?? null;
  try {
    const { text: out, warnings } = await expand(text, {
      chars,
      macros,
      sheet: s.game?.settings.sheet || "dnd5e",
      asChar: as ? s.recs.char[as] : null,
      selected,
      ask: async (q, options, dflt) => (options ? choose(q, options) : prompt(q, dflt)),
    });
    for (const w of warnings) localNote(w);
    // multi-line macros: each line is its own message (like Roll20)
    const lines = out.includes("&{template:") ? [out] : out.split("\n").filter(l => l.trim());
    for (const line of lines) send({ t: "chat", text: line, as: as || undefined, selected: ui.selected });
  } catch (e) {
    if (!(e instanceof ExpandCancelled)) localNote(String((e as any)?.message || e));
  }
}

export function localNote(text: string) {
  const s = G.get();
  G.set({ chat: [...s.chat, { id: -Date.now(), ts: Date.now(), uid: "", who: "Hearth", type: "system", segs: [{ t: "text", v: text }] }] });
}
